---
meta:
  - title: Como usar Transcripciones - IUSPRO Docs
  - description: Guía de uso de la herramienta de transcripciones.
---

# Como usar Transcripciones

La herramienta de transcripciones le permite convertir archivos de audio o video en texto escrito. Es especialmente útil para audiencias.

## ¿Cuándo usar Transcripciones?

El uso más común es cuando tiene una audiencia grabada en archivo de video o audio y necesita una transcripción escrita de todo lo que se dijo.

## Como crear una transcripción

1. **Haga clic en "Nueva transcripción"**
2. **Suba el archivo de audio o video**
3. **Espere la notificación por correo**

No tiene que estar pendiente de la plataforma. Una vez que la transcripción termine, recibirá un correo electrónico.

## Notificación por correo

El correo que recibe contiene:

- Confirmación de que la transcripción está lista
- Un link que lo lleva directamente a la página de la transcripción en la plataforma

## Descargar la transcripción

Una vez lista, puede descargar la transcripción en formato **Word** directamente desde la plataforma.

## Gestión de transcripciones

- Todas sus transcripciones quedan listadas en la sección de Transcripciones
- Puede borrar transcripciones cuando ya no las necesite
- Siempre tendrá acceso a su historial de transcripciones

Esta herramienta es bastante sencilla de usar y le ahorra mucho tiempo en la tarea de transcribir audiencias manualmente.
